import { makeStyles } from "tss-react/mui";

const useCompletionStyles = makeStyles()((theme) => ({
  mainContainer: {
    flexGrow: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: theme.palette.surface.darker,
  },
  header: {
    borderBottom: `1px solid ${theme.palette.strokes.defaultGrey}`,
    backgroundColor: theme.palette.surface.light,
  },
  container: {
    marginBottom: theme.spacing(1),
  },
  note: {
    borderTop: `1px solid ${theme.palette.strokes.defaultGrey}`,
    borderBottom: `1px solid ${theme.palette.strokes.defaultGrey}`,
    padding: "8px 10px",
    backgroundColor: theme.palette.surface.light,
  },
  warning: {
    backgroundColor: theme.palette.status.caution,
    padding: "8px 16px",
    color: theme.palette.surface.navigation,
    fontSize: "1rem",
    display: "flex",
    gap: "5px",
    alignItems: "center",
  },
  actionButtonsContainer: {
    padding: "8px 25px",
    backgroundColor: theme.palette.surface.navigation,
  },
  actionButtons: {
    backgroundColor: theme.palette.surface.bg,
    color: theme.palette.text.primary,
    textTransform: "none",
  },
}));

export default useCompletionStyles;
